import { render } from "./MediaDeviceNotSupported.vue?vue&type=template&id=2364173d&scoped=true&ts=true"
import script from "./MediaDeviceNotSupported.ts?vue&type=script&lang=ts&external"
export * from "./MediaDeviceNotSupported.ts?vue&type=script&lang=ts&external"

import "./MediaDeviceNotSupported.scss?vue&type=style&index=0&id=2364173d&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2364173d"]])

export default __exports__